import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import FeedbackLink from 'components/links/Feedback';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';
import logger from 'conf/Logger';
import {useGet} from 'helpers/KyHooks';


const propTypes = {
  message: PropTypes.string,
  prevUrl: PropTypes.string,
};

export default function FeedbackPage({message, prevUrl}) {
  const {response, error} = useGet('site/announcement');

  if (error) {
    logger.warn(error);
  }
  return (
    <ReadableWidthTemplate title="Contact Us">
      { response && <div className="alert alert-warning" dangerouslySetInnerHTML={{__html: response.data}} />}
      <p>
        We welcome any questions or feedback you might have for ClinPGx.
      </p>
      <p>
        Use the button below or send to <a href={`mailto:feedback@clinpgx.org?subject=${encodeURIComponent('ClinPGx Feedback')}`}>feedback@clinpgx.org</a>
      </p>
      <p>
        <FeedbackLink body={message} srcUrl={prevUrl} className="btn btn-primary btn-lg">
          <FontAwesomeIcon icon="envelope" className="faIcon--textOnRight" />
          Send Feedback
        </FeedbackLink>
      </p>
    </ReadableWidthTemplate>
  );
}

FeedbackPage.propTypes = propTypes;
